import {
  useEmbedConfigureStore,
  type IComponentSettings
} from '@/stores/embeds/embedConfigure.store'
import { useIdeStore } from '@/stores/embeds/ide.store'
import { JDOODLEBLOCKSNAMES } from '@/utils/embeds/editorMeta'
/**
 * On setting change
 */
const onSettingChange = () => {
  const settongs = useEmbedConfigureStore().getComponentSettings?.find(
    (componentSetting: IComponentSettings) =>
      componentSetting.componentName === JDOODLEBLOCKSNAMES.INPUTARGS
  )?.configStyle
  const hideTitle = settongs?.find((setting) => setting.id === 'hideTitle')?.value || 'true'
  useIdeStore().setInputArgsHideTitle(hideTitle === 'true' || false)
  const titleName =
    settongs?.find((setting) => setting.id === 'titleName')?.value || 'Input Arguments:'
  useIdeStore().setInputArgsTitleName(titleName)
  const display = settongs?.find((setting) => setting.id === 'display')?.value || 'true'
  useIdeStore().setInputArgsDisplay(display === 'true' || false)
  const lines = settongs?.find((setting) => setting.id === 'lines')?.value || '2'
  useIdeStore().setInputArgsLines(parseInt(lines) || 2)
}
/**
 * Init language list
 */
const initInputArgus = () => {
  const defaultInputArgs = useEmbedConfigureStore().getEmbedConfig?.defaultConfig?.inputArgs || ''
  useIdeStore().setInputArgs(defaultInputArgs)
}
/**
 * Eject input argus
 */
const destroyInputArgus = () => {
  const defaultInputArgs = useEmbedConfigureStore().getEmbedConfig?.defaultConfig?.inputArgs || ''
  useIdeStore().setInputArgs(defaultInputArgs)
}
export default {
  initInputArgus,
  onSettingChange,
  destroyInputArgus
}
